import moment from 'moment'

export const startOfMonth = moment(new Date()).startOf('month').format('YYYY-MM-DD')
export const endOfMonth = moment(new Date()).endOf('month').format('YYYY-MM-DD')
export const todayDate = moment(new Date()).format('YYYY-MM-DD')
export const currentMonth = moment(new Date()).format('MMMM')
export const currentYear = moment(new Date()).format('YYYY')
export const lastMonth = moment(new Date()).add(-1, 'months').format('MMMM')
export const lastYear = moment(new Date()).add(-1, 'years').format('YYYY')

export const startOfYear = moment(new Date()).startOf('years').format('YYYY-MM-DD')
export const endOfYear = moment(new Date()).endOf('years').format('YYYY-MM-DD')

export const checkValidNumber = (value) => {

    // verifica isNaN
    if (isNaN(value)) {
        return 0
    }

    // verifica Infinity
    if (value === Infinity || value === 'Infinity' || value === '-Infinity' || value === -Infinity) {
        return 0
    }

    return value

}

export const getTotalWithTaxes = async ({ amount, tax_percent, type }) => {
    const newAmount = parseFloat(amount)

    if (type === 'directo') {
        const factor = (tax_percent / 100) + 1
        return await checkRoundDecimals(newAmount * factor, 2)
    }

    if (type === 'retencion') {
        const factor = 1 - (tax_percent / 100)
        return await checkRoundDecimals(newAmount * factor, 2)
    }

    return newAmount

}

export const checkRoundDecimals = async (value, precision = 2) => {
    // console.log('intial info rounded--', value, precision)

    // percent = 2 decimals maximos = ej: 70.28%
    // amounts = 6 decimals maximos  = ej: $14656.765434

    const newValue = parseFloat(value || 0)

    // verifica undefined
    if (newValue === undefined || value === 'undefined') {
        return 0
    }

    // verifica isNaN
    if (isNaN(newValue)) {
        return 0
    }

    // verifica Infinity
    if (newValue === Infinity || value === 'Infinity' || value === '-Infinity' || value === -Infinity) {
        return 0
    }

    const roundedValue = parseFloat(newValue?.toFixed(precision))
    return roundedValue

}

export const getTotalWithTaxes2 = ({ amount, tax_percent, type }) => {
    const newAmount = parseFloat(amount)

    if (type === 'directo') {
        const factor = (tax_percent / 100) + 1
        return checkRoundDecimals2(newAmount * factor, 2)
    }

    if (type === 'retencion') {
        const factor = 1 - (tax_percent / 100)
        return checkRoundDecimals2(newAmount * factor, 2)
    }

    return newAmount

}

export const checkRoundDecimals2 = (value, precision = 2) => {
    // console.log('intial info rounded--', value, precision)

    // percent = 2 decimals maximos = ej: 70.28%
    // amounts = 6 decimals maximos  = ej: $14656.765434

    const newValue = parseFloat(value || 0)

    // verifica undefined
    if (newValue === undefined || value === 'undefined') {
        return 0
    }

    // verifica isNaN
    if (isNaN(newValue)) {
        return 0
    }

    // verifica Infinity
    if (newValue === Infinity || value === 'Infinity' || value === '-Infinity' || value === -Infinity) {
        return 0
    }

    const roundedValue = parseFloat(newValue?.toFixed(precision))
    return roundedValue

}

export const getSuppliersItemsPpto = async (titles) => {
    let suppliers = []

    for (let x = 0; x < titles.length; x++) {
        const items = titles[x].items

        for (let y = 0; y < items.length; y++) {
            suppliers = [
                ...suppliers,
                {
                    id: items[y].id_proveedor,
                    nombre: items[y].nombre_proveedor,
                    costo: items[y].costo_subtotal,
                    id_item: items[y].id,
                    descripcion: items[y].nombre_proveedor + " / " + items[y].nombre
                }
            ]
        }

    }

    return suppliers

}

export const getCalcTotalSumExpenses = (expensesList) => {
    let totalExpenses = 0
    for (let x = 0; x < expensesList.length; x++) {
        if (!expensesList[x].deleted) {
            totalExpenses = totalExpenses + parseFloat(expensesList[x].total)
        }
    }
    return totalExpenses
}

export const getCalcTotalSumIncomes = (incomeList) => {
    let totalIncome = 0
    for (let x = 0; x < incomeList.length; x++) {
        if (!incomeList[x].deleted) {
            totalIncome = totalIncome + parseFloat(incomeList[x].monto_neto)
        }
    }
    return totalIncome
}